export const AiActionTypes = {
  TOGGLE_AI: 'TOGGLE_AI',
  GET_CONVERSATION_LIST: 'GET_CONVERSATION_LIST',
} as const;

interface ConversationItem {
  id: string;
  type: 'query' | 'general' | 'explaination' | 'response' | 'data_table' | string;
  msg: string | Record<string, unknown>;
}

// Interface for the GET_CONVERSATION_LIST action
export interface GetConversationListAction {
  type: typeof AiActionTypes.GET_CONVERSATION_LIST; // Use the renamed constant here
  payload: ConversationItem[];
}

export const openAiscreen = (payload: boolean) => ({
  type: AiActionTypes.TOGGLE_AI, // Use the renamed constant here
  payload,
});

export const getConversationAction = (payload: ConversationItem[]): GetConversationListAction => ({
  type: AiActionTypes.GET_CONVERSATION_LIST, // Use the renamed constant here
  payload,
});

export const aiActionTypes = {
  openAiscreen,
  getConversationAction,
};
